import { render, staticRenderFns } from "./btnBack.vue?vue&type=template&id=375a4a1e&scoped=true&"
import script from "./btnBack.vue?vue&type=script&lang=js&"
export * from "./btnBack.vue?vue&type=script&lang=js&"
import style0 from "./btnBack.vue?vue&type=style&index=0&id=375a4a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375a4a1e",
  null
  
)

export default component.exports